import './styles/InfoBox.scss';

import {
  BuildOutlined,
  ErrorOutlined,
  ExpandMore,
  InfoOutlined,
  WarningOutlined
} from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  Grid
} from '@mui/material';

import clsx from 'clsx';
import { ReactElement, useState } from 'react';

interface Props {
  type: 'info' | 'warning' | 'error' | 'maintenance' | 'incident';
  title: string;
  children: React.ReactNode;
  expandable?: boolean;
  collapsed?: boolean;
}

export default function InfoBox({
  type = 'info',
  title,
  children,
  expandable,
  collapsed
}: Props): ReactElement {
  const getBoxIcon = () => {
    switch (type) {
      case 'info':
        return <InfoOutlined className="info-box__header__icon" />;
      case 'error':
        return <ErrorOutlined className="info-box__header__icon" />;
      case 'warning':
        return <WarningOutlined className="info-box__header__icon" />;
      case 'maintenance':
        return <BuildOutlined className="info-box__header__icon" />;
      case 'incident':
        return <ErrorOutlined className="info-box__header__icon" />;
    }
  };
  const [expanded, setExpanded] = useState(expandable && !collapsed);

  if (expandable) {
    return (
      <Accordion
        className={clsx('info-box', 'info-box--accordion', { [`info-box--${type}`]: type })}
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        elevation={0}
        variant="outlined"
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Grid container className="info-box__header info-box__header--accordion">
            <Grid item xs="auto">
              {getBoxIcon()}
            </Grid>
            <Grid item xs>
              {title}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails className="info-box__content info-box__content--accordion">
          <Grid container>
            <Grid item xs>
              {children}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <Card className={clsx('info-box', { [`info-box--${type}`]: type })} variant="outlined">
      <Grid container className="info-box__header">
        <Grid item xs="auto">
          {getBoxIcon()}
        </Grid>
        <Grid item xs>
          {title}
        </Grid>
      </Grid>
      <CardContent className="info-box__content">{children}</CardContent>
    </Card>
  );
}
